module.exports = __webpack_public_path__ + "static/banner1-65b9505825e9be3b0f0d59a266bc34e5.jpg";